import React from "react";
import {Loader, middleware, RouteType} from "shared/utils/RouteUtiles";

/**
 * 장비사용 신청 관련 라우터
 */
export const EquipmentRoutes: RouteType[] = [
  {
    path: '/tsp/Apply/Equipment',
    label: '장비사용 신청 목록',
    element: (
      <Loader
        route={middleware(
          {
            label: 'ApplyEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Equipment/ApplyEquipment")),
          },
          [] // 비회원도 접근 가능
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Equipment/UseEquipmentApply/:id',
    label: '장비사용 신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'dashboard',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Equipment/UseEquipmentApply/UseEquipmentApply")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Equipment/ApplyForm/:id',
    label: '장비사용 신청서 작성',
    element: (
      <Loader
        route={middleware(
          {
            label: 'EquipmentApplyForm',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Equipment/EquipmentApplyForm")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Estimation/ApplyForm/:id',
    label: '장비 견적요청서 작성',
    element: (
      <Loader
        route={middleware(
          {
            label: 'EstimationApplyForm',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Estimation/EstimationApplyForm")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Apply/Equipment/:id',
    label: '장비사용장비상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'ApplyEquipmentDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Apply/Equipment/ApplyEquipmentSelect")),
          },
          [] // 상세 화면은 비회원도 접근 가능
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Equipment',
    label: '마이페이지 장비사용 목록',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MyPageEquipment',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Equipment/MyPageEquipment")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Equipment/:id',
    label: '마이페이지 장비사용 상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MyPageEquipmentDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Equipment/MyPageEquipmentDetail/MyPageEquipmentDetail")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Equipment/ApplyPeriodExtension/:id',
    label: '마이페이지 장비사용 상세 기간 연장 신청',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MyPageEquipmentDetail',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Equipment/ApplyPeriodExtension")),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/tsp/Mypage/Equipment/UseEquipmentModify/:id',
    label: '마이페이지 장비신청 수정',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MyPageEquipmentModify',
            layout: 'basic',
            element: React.lazy(() => import("../pages/Mypage/Equipment/MyPageEquipmentDetail/UseEquipmentModify")),
          },
          ['auth']
        )}
      />
    ),
  },
].map((route: Partial<RouteType>) => ({
  ...route,
  layout: 'space',
})) as RouteType[];

